import React from "react";

import { Button, Heading, Text } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

import { clickedNewSearch } from "../../../../../tracking/account-tracking";
import { BusMutedAgnosticIllustration } from "../../illustrations/bus-muted-agnostic";

export const NoTrips = () => {
  const { urlBuilder, tracker, translator } = useAppContext();

  return (
    <div className="flex flex-col items-center gap-300">
      <BusMutedAgnosticIllustration />
      <div className="flex flex-col items-center gap-050">
        <Heading
          size="md"
          className="text-center text-color-secondary"
          as="span"
        >
          {translator.t("!accounts.my-tickets.no-upcoming-trips")}
        </Heading>
        <Text size="md" className="text-color-tertiary" as="span">
          {translator.t("!accounts.trips.explore-world")}
        </Text>
      </div>
      <Button
        size="lg"
        url={urlBuilder.home()}
        onClick={() => tracker.track(clickedNewSearch())}
        appearance="primary"
      >
        {translator.t("!accounts.my-tickets.empty.button")}
      </Button>
    </div>
  );
};
